import { statusText } from "../lib/displayNames";

export function StatusBadge({ value }: { value: string }) {
  const tone = ["active", "ready", "ok", "approved", "healthy", "delivered", "verified"].includes(value) ? "success"
    : ["suspended", "revoked", "expired", "archived", "failed", "dead", "past_due", "canceled", "frozen"].includes(value) ? "danger"
      : ["provisioning", "pending", "provisioned", "rotating", "processing", "trialing", "unverified", "unchecked"].includes(value) ? "warning" : "neutral";
  // 未知枚举统一产品化为「状态待识别」，原始技术值只允许进入授权技术证据区。
  return <span className={`status ${tone}`}><i />{statusText(value)}</span>;
}
